"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfChatbotItemOutput = instanceOfChatbotItemOutput;
exports.ChatbotItemOutputFromJSON = ChatbotItemOutputFromJSON;
exports.ChatbotItemOutputFromJSONTyped = ChatbotItemOutputFromJSONTyped;
exports.ChatbotItemOutputToJSON = ChatbotItemOutputToJSON;
var Metadata_1 = require("./Metadata");
var ChatbotItem_1 = require("./ChatbotItem");
/**
 * Check if a given object implements the ChatbotItemOutput interface.
 */
function instanceOfChatbotItemOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ChatbotItemOutputFromJSON(json) {
    return ChatbotItemOutputFromJSONTyped(json, false);
}
function ChatbotItemOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(ChatbotItem_1.ChatbotItemFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function ChatbotItemOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(ChatbotItem_1.ChatbotItemToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
